var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1561",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 4L3.244 8.963L3.4 10L3.989 13.926C3.99546 13.9754 3.99913 14.0252 4 14.075C4.04035 15.1502 4.92407 16.0008 6 16H10C11.047 16.0003 11.917 15.1931 11.995 14.149C12.002 14.049 12.008 13.949 12.023 13.849L12.6 10L13.5 4H2.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1561-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 10C6.5 8.9 7.172 8 8 8C8.828 8 9.5 8.9 9.5 10C9.5 11.1 8.828 12 8 12C7.172 12 6.5 11.1 6.5 10Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1561-3",
    d: "M2.5 4.75C2.91421 4.75 3.25 4.41421 3.25 4C3.25 3.58579 2.91421 3.25 2.5 3.25V4.75ZM1 3.25C0.585786 3.25 0.25 3.58579 0.25 4C0.25 4.41421 0.585786 4.75 1 4.75V3.25ZM7.28849 3.76283C7.1575 4.15579 7.36987 4.58053 7.76283 4.71151C8.15579 4.8425 8.58053 4.63013 8.71151 4.23717L7.28849 3.76283ZM8.772 1.684L9.48351 1.92117L9.48357 1.921L8.772 1.684ZM9.721 1L9.72082 1.75H9.721V1ZM11 1.75C11.4142 1.75 11.75 1.41421 11.75 1C11.75 0.585786 11.4142 0.25 11 0.25V1.75ZM13.5 3.25C13.0858 3.25 12.75 3.58579 12.75 4C12.75 4.41421 13.0858 4.75 13.5 4.75V3.25ZM15 4.75C15.4142 4.75 15.75 4.41421 15.75 4C15.75 3.58579 15.4142 3.25 15 3.25V4.75ZM6.0885 10.627C6.43479 10.8543 6.89976 10.7578 7.12703 10.4115C7.3543 10.0652 7.2578 9.60024 6.9115 9.37297L6.0885 10.627ZM2.9885 9.37297C2.6422 9.60024 2.5457 10.0652 2.77297 10.4115C3.00024 10.7578 3.46521 10.8543 3.8115 10.627L2.9885 9.37297ZM9.81021 9.31716C9.43309 9.14584 8.98849 9.31267 8.81716 9.68979C8.64584 10.0669 8.81267 10.5115 9.18979 10.6828L9.81021 9.31716ZM13.1575 10.5017C13.4346 10.1938 13.4096 9.71962 13.1017 9.44253C12.7938 9.16544 12.3196 9.19039 12.0425 9.49828L13.1575 10.5017ZM2.5 3.25H1V4.75H2.5V3.25ZM8.71151 4.23717L9.48351 1.92117L8.06049 1.44683L7.28849 3.76283L8.71151 4.23717ZM9.48357 1.921C9.51759 1.81886 9.61317 1.74997 9.72082 1.75L9.72118 0.25C8.96762 0.249819 8.29856 0.73205 8.06043 1.447L9.48357 1.921ZM9.721 1.75H11V0.25H9.721V1.75ZM13.5 4.75H15V3.25H13.5V4.75ZM6.9115 9.37297C5.72061 8.59142 4.17939 8.59142 2.9885 9.37297L3.8115 10.627C4.50272 10.1734 5.39728 10.1734 6.0885 10.627L6.9115 9.37297ZM9.18979 10.6828C9.61098 10.8742 10.2867 11.1029 10.9814 11.1713C11.6398 11.236 12.5498 11.1769 13.1575 10.5017L12.0425 9.49828C11.9302 9.62308 11.6567 9.73046 11.1283 9.67848C10.6363 9.63008 10.122 9.45881 9.81021 9.31716L9.18979 10.6828Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoda);
export default __webpack_public_path__ + "static/media/soda.9e4dad9aef3d2c5503827c86da9f43fb.svg";
export { ForwardRef as ReactComponent };